import { DomainError } from "@econ-v1/domain";
export function createOutboxStatusQuery(repository) {
    return {
        invalidateOn: ["outbox.state-changed", "domain.entity-changed"],
        key: (row) => row.id,
        name: "sync.outbox-status.v1",
        run: async (params) => await repository.list(parseOutboxStatusQueryParams(params)),
    };
}
export function parseOutboxStatusQueryParams(value) {
    const record = exactRecord(value, ["domain", "state"], "outbox status");
    if (record.domain !== undefined && typeof record.domain !== "string")
        invalid("outbox status");
    if (record.state !== undefined && !OUTBOX_STATES.includes(record.state)) {
        invalid("outbox status");
    }
    return {
        ...(record.domain === undefined ? {} : { domain: record.domain }),
        ...(record.state === undefined ? {} : { state: record.state }),
    };
}
const OUTBOX_STATES = ["acknowledged", "conflict", "failed", "pending", "replaying"];
export function exactRecord(value, allowedKeys, label) {
    if (value === null || typeof value !== "object" || Array.isArray(value))
        invalid(label);
    const record = value;
    if (Object.keys(record).some((key) => !allowedKeys.includes(key)))
        invalid(label);
    return record;
}
export function invalid(label) {
    throw new DomainError({ code: "invalid_request", message: `Invalid ${label} query parameters` });
}
//# sourceMappingURL=outbox-status.js.map